import { makeActionCreator } from '../../../utilities'
import { InsuranceInformationConstants } from './insuranceInformation.constants'

export const setInsurancecarrier = makeActionCreator(
  InsuranceInformationConstants.SET_INSURANCE_CARRIER,
  'insuranceCarrier'
)
export const setGroupname = makeActionCreator(InsuranceInformationConstants.SET_GROUP_NAME, 'groupName')
export const setGroupNumber = makeActionCreator(InsuranceInformationConstants.SET_GROUP_NUMBER, 'groupNumber')
export const setPolicy = makeActionCreator(InsuranceInformationConstants.SET_POLICY, 'policy')
export const setPriority = makeActionCreator(InsuranceInformationConstants.SET_PRIORITY, 'priority')
export const setInsured = makeActionCreator(InsuranceInformationConstants.SET_INSURED, 'insured')
export const setActive = makeActionCreator(InsuranceInformationConstants.SET_ACTIVE, 'active')
export const setInsuranceInformationList = makeActionCreator(
  InsuranceInformationConstants.SET_INSURANCE_INFORMATION_LIST,
  'insuranceInformationList'
)
export const addInsuranceInformation = makeActionCreator(InsuranceInformationConstants.ADD_INSURANCE_INFORMATION)
export const removeInsuranceInformation = makeActionCreator(
  InsuranceInformationConstants.REMOVE_INSURANCE_INFORMATION,
  'selectedInsuranceKey'
)
export const saveInsuranceInformation = makeActionCreator(InsuranceInformationConstants.SAVE_INSURANCE_INFORMATION)
export const clearInsuranceInformationData = makeActionCreator(
  InsuranceInformationConstants.CLEAR_INSURANCE_INFORMATION_DATA
)
export const resetInsuranceInformationState = makeActionCreator(InsuranceInformationConstants.RESET_STATE)
export const setInsuranceInformationState = makeActionCreator(
  InsuranceInformationConstants.SET_INSURANCE_INFORMATION_STATE,
  'insuranceInformationState'
)
export const setInsuranceInformationData = makeActionCreator(
  InsuranceInformationConstants.SET_INSURANCE_INFORMATION_DATA,
  'insuranceInformationData'
)
